import { Ng2StateDeclaration } from '@uirouter/angular';
import { Injectable } from '@angular/core';
import { StateService, Transition } from '@uirouter/core';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { MonUIRouterTransitionService } from '@monsido/ng2/services/ui-router-transition-service/ui-router-transition-service';
import { AdminLayoutService } from '@client/app/feature-modules/admin/services/admin-layout.service';
import { AdminJiraConnectorComponent } from '../components/admin-jira-connector/admin-jira-connector.component';
import { JIRA_CONNECTOR_CONSTANT } from '@client/app/feature-modules/jira-connector/constants/jira-connector.constant';

@Injectable({ providedIn: 'root' })
export class JiraConnectorAccessGuard {
    constructor (
        private activeFeatureService: ActiveFeatureService,
        private stateService: StateService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
    ) {}

    checkAccess (transition: Transition) {
        if (this.activeFeatureService.isFeatureActive(JIRA_CONNECTOR_CONSTANT.PLAN_TRAIT)) {
            return true;
        }
        const params = transition.params();
        return this.monUIRouterTransitionService.onTransitionFinished(() => {
            return this.stateService.go('base.customer.admin.dashboard', params) as unknown as Promise<void>;
        });
    }
}

export const AdminJiraConnectorStates: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.admin.jira-connector',
        url: '/jira-connector',
        resolve: [
            {
                token: 'jiraConnectorAccess',
                deps: [JiraConnectorAccessGuard, Transition],
                resolveFn: (guard: JiraConnectorAccessGuard, transition: Transition) =>
                    guard.checkAccess(transition),
            },
            {
                token: 'breadcrumbs',
                deps: [AdminLayoutService],
                resolveFn: (adminLayoutService: AdminLayoutService) => {
                    adminLayoutService.setBreadcrumbs({
                        uiStates: [
                            {
                                label: 'admin.jiraConnector.breadcrumbLabel',
                                state: 'base.customer.admin.jira-connector',
                            },
                        ],
                    });
                },
            },
        ],
        component: AdminJiraConnectorComponent,
        data: {
            /** Shell-facing path for CC breadcrumb/menu sync (see event-bus-bridge.init.ts) */
            shellPath: '/admin/jira-connector',
        },
    },
];
